// extracted by mini-css-extract-plugin
export default {"productGrid":"T2-z","centerLink":"U2-z","productSection":"V2-z","item":"W2-z","ctaButton":"X2-z"};